"use strict";

module.exports = require("./is-implemented")() ? Object.setPrototypeOf : require("./shim");



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/es5-ext/object/set-prototype-of/index.js
// module id = ../../../../es5-ext/object/set-prototype-of/index.js
// module chunks = 4